import { Page, Text, View, Document, StyleSheet, Font } from "@react-pdf/renderer";

Font.register({
    family: "Vazirmatn",
    src: "/fonts/Vazirmatn-Regular.ttf",
});

const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        padding: 20,
        direction: "rtl",
        fontFamily: "Vazirmatn",
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {
        flexDirection: "row-reverse",
    },
    cell: {
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 4,
        fontSize: 12,
        flexGrow: 1,
        width: '7rem',
        direction: 'rtl',
        textAlign: 'right',
    },
    headerCell: {
        backgroundColor: "#eee",
        fontSize: 12,
        padding: 4,
        fontFamily: "Vazirmatn",
    },
});

export default function MyGridPdf({ columns, rows, title }) {
    //    console.log(columns);

    const isVisible = col => col.visible !== false && (col.dataField || col.name === '_sequence');

    return (
        <Document title={title ?? ''}>
            <Page size='A2' style={styles.page} orientation='landscape'
            >
                {/* Header row */}
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        {columns.filter(isVisible)?.map((col, i) => (
                            <Text key={i} style={[styles.cell, styles.headerCell, { width: col.width ?? 1 }]} >
                                {col.caption || col.dataField}
                            </Text>
                        ))}
                    </View>

                    {/* Data rows */}
                    {rows.map((row, rIndex) => (
                        <View key={rIndex} style={styles.tableRow}>
                            {row.map((cell, cIndex) => (
                                isVisible(columns[cIndex]) &&
                                <Text key={cIndex} style={[styles.cell, { width: columns[cIndex].width ?? 1 }]}
                                >
                                    {String(cell)}
                                </Text>
                            ))}
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );
}
